import { useCallback, useRef, useState } from 'react';
import cx from 'classnames';

import { SaleStats } from './SaleStats/SaleStats';
import { SocialValidation } from './SocialValidation/SocialValidation';

import styles from './CompanyStats.scss';

export const CompanyStats = () => {
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const listRef = useRef<HTMLUListElement>(null);

  const onScroll = useCallback(() => {
    const el = listRef.current;
    if (!el) {
      return;
    }
    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  }, []);

  return (
    <div className={cx(styles.wrapper, { [styles.showLeft]: showLeft, [styles.showRight]: showRight })}>
      <ul ref={listRef} className={styles.list} onScroll={onScroll}>
        <li className={styles.tile}>
          <SaleStats />
        </li>
        <li className={styles.tile}>
          <SocialValidation />
        </li>
      </ul>
    </div>
  );
};
